import { SCREENS } from '@/constants';
import { makeUseMatchMediaHook } from '@tallinn-arvudes/ui/hooks';

export const useMatchMedia = makeUseMatchMediaHook(SCREENS);
